import script from "./BuildingDetailsWidget.vue?vue&type=script&lang=ts&setup=true"
export * from "./BuildingDetailsWidget.vue?vue&type=script&lang=ts&setup=true"

import "./BuildingDetailsWidget.vue?vue&type=style&index=0&id=09f3679d&lang=less&scoped=true"

import exportComponent from "/var/build/production/tenants-portal/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-09f3679d"]])

export default __exports__